<template>
    <component
        :is="isExternalLinkFlag ? 'a' : 'nuxt-link'"
        v-bind="linkAttributes"
        class="btn_reset icon_cart"
        :aria-label="isMobile ? shopButton.title : null"
    >
        <div class="icon">
            <picture v-full-image-path:assets.decorative="'icon_cart.svg'" />
        </div>
        <div v-if="!isMobile" class="title">
            {{ shopButton.title }}
        </div>
    </component>
</template>

<script>
import isExternalLink from '@/helpers/isExternalLink';

export default {
    props: {
        shopButton: {
            type: Object,
            required: true
        },

        isMobile: {
            type: Boolean,
            default: false
        }
    },

    computed: {
        link() {
            return this.shopButton.link;
        },

        isExternalLinkFlag() {
            return isExternalLink(this.link);
        },

        linkAttributes() {
            if (this.isExternalLinkFlag) {
                return {
                    href: this.link,
                    target: '_blank',
                    rel: 'noopener noreferrer'
                };
            }

            return {
                to: this.localePath(this.link)
            };
        }
    }
};
</script>
